import { useState, useEffect, useCallback } from "react";
import {
  getCollection,
  subscribeToCollection,
} from "../services/firestoreService";

export const useCollection = (
  collectionName,
  constraints = [],
  realtime = true, // ⚡ Cambiar a true por defecto
) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Convertir constraints a string para la dependencia del useEffect
  const constraintsKey = JSON.stringify(constraints);

  useEffect(() => {
    setLoading(true);
    console.log(`🔄 Cargando colección: ${collectionName}`, { realtime, constraints });

    if (realtime) {
      const unsubscribe = subscribeToCollection(
        collectionName,
        (newData) => {
          console.log(`✅ Datos recibidos de ${collectionName}:`, newData?.length, 'documentos');
          setData(newData);
          setLoading(false);
        },
        constraints,
      );
      return () => {
        console.log(`🛑 Desuscribiendo de ${collectionName}`);
        unsubscribe();
      };
    } else {
      getCollection(collectionName, constraints)
        .then((result) => {
          console.log(`✅ Datos cargados de ${collectionName}:`, result?.length);
          setData(result);
        })
        .catch((err) => {
          console.error(`❌ Error cargando ${collectionName}:`, err);
          setError(err);
        })
        .finally(() => setLoading(false));
    }
  }, [collectionName, constraintsKey]); // ⚡ Agregar constraintsKey

  return { data, loading, error, setData };
};